import { useEffect, useState } from "react";
import VariantButton from "../variant-button/variant-button";
import axios from "axios";
import api from "../../services/api";

const MAX_FILE_SIZE = 5 * 1024 * 1024;

export default function ImageUpload() {
  const [preview, setPreview] = useState("");
  const [uploadResult, setUploadResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [copyBtn, setCopyBtn] = useState("Sao chép");
  const [isOpen, setIsOpen] = useState(false); // mở/đóng panel nổi

  useEffect(() => {
    return () => {
      if (preview) {
        URL.revokeObjectURL(preview);
      }
    };
  }, [preview]);

  const handleImageChange = async (event) => {
    try {
      const file = event.target.files?.[0];
      if (!file) return;

      const allowedTypes = [
        "image/jpeg",
        "image/png",
        "image/webp",
        "image/gif",
      ];

      if (!allowedTypes.includes(file.type)) {
        setError("Chỉ cho phép ảnh JPG, PNG, WEBP hoặc GIF");
        return;
      }

      if (file.size > MAX_FILE_SIZE) {
        setError("Ảnh không được vượt quá 5MB");
        return;
      }

      setError("");
      setUploadResult(null);
      setPreview(URL.createObjectURL(file));
      setLoading(true);

      const url = process.env.REACT_APP_POCKETBASE;
      const response = await axios.post(
        `${url}/api/collections/_superusers/auth-with-password`,
        {
          identity: process.env.REACT_APP_IDENTITY,
          password: process.env.REACT_APP_PASSWORD,
        },
      );

      const { token } = response.data;

      if (token) {
        const formData = new FormData();
        formData.append("image", file);

        const upload = await axios.post(
          `${url}/api/collections/blog_images/records`,
          formData,
          {
            headers: {
              Authorization: token,
              "Content-Type": "multipart/form-data",
            },
          },
        );

        const { id, collectionName, image } = upload.data;
        const image_url = `${url}/api/files/${collectionName}/${id}/${image}`;

        setUploadResult({
          url: image_url,
          message: "Tải ảnh thành công !",
        });
        setLoading(false);

        if (upload.status === 200) {
          await api.post("/blogs/images", { image_url: image_url });
        }
      }
    } catch (error) {
      setError("Tải ảnh không thành công :((");
      setLoading(false);
    }
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(uploadResult.url);
      setCopyBtn("Đã sao chép");
      setTimeout(() => {
        setCopyBtn("Sao chép");
      }, 1000);
    } catch (error) {
      setError("Sao chép thất bại :((");
    }
  };

  return (
    <>
      <div className="w-[120px] fixed bottom-6 right-6 z-50 ">
        <VariantButton
          props={{ title: "Tải ảnh", onClick: () => setIsOpen(!isOpen) }}
        />
      </div>

      {isOpen && (
        <div className="fixed bottom-24 right-6 z-50 w-[360px] max-w-[90vw] bg-white rounded-md shadow-2xl border border-gray-200 p-4 animate-in fade-in slide-in-from-bottom-4">
          <div className="flex justify-between items-center mb-3">
            <h3 className="font-semibold text-gray-800">Tải ảnh</h3>
            <button
              onClick={() => setIsOpen(false)}
              className="text-gray-500 hover:text-gray-800 text-xl leading-none"
            >
              ×
            </button>
          </div>

          <input
            type="file"
            accept="image/jpeg,image/png,image/webp,image/gif"
            onChange={handleImageChange}
            className="w-full text-sm"
          />

          {preview && (
            <div className="mt-3">
              <p className="text-sm text-gray-600 mb-1">Ảnh xem trước:</p>
              <img
                src={preview}
                alt="Preview"
                className="h-[160px] w-full object-contain rounded-md"
              />
            </div>
          )}

          {loading && <p className="mt-2 text-sm text-blue-600">Đang tải...</p>}

          {error && <p className="mt-2 text-sm text-red-600">{error}</p>}

          {uploadResult && (
            <div className="mt-3 space-y-2">
              <p className="text-green-600 text-sm font-medium">
                {uploadResult?.message || ""}
              </p>

              <input
                className="bg-gray-100 w-full p-2 rounded-md text-green-900 text-sm"
                type="text"
                value={uploadResult?.url || ""}
                readOnly
              />

              <div className="flex gap-2">
                <div className="flex-1">
                  <VariantButton
                    props={{ title: copyBtn, onClick: handleCopy }}
                  />
                </div>
                <div className="flex-1">
                  <VariantButton
                    props={{
                      title: "Xem ảnh",
                      onClick: () => {
                        window.open(uploadResult?.url);
                      },
                    }}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
}
